// src/constants/affiliationBoards.js
const affiliationBoardOptions = [
  "CBSE",
  "ICSE",
  "State Board",
  "IB",
  "Cambridge (IGCSE)",
  "Others",
];

export default affiliationBoardOptions;
